const TolstoyOpener = (tolstoyId) => {
	// let tolstoyId = "0l4hoe5yxvtk4";
	document.addEventListener("DOMContentLoaded", () => {
		const openTolstoy = document.querySelectorAll(".btn--tolstoy-open");

		if (openTolstoy.length) {
			openTolstoy.forEach((link) => {
				link.addEventListener("click", (e) => {
					// tolstoyId = link.getAttribute("data-tolstoy-id");
					e.preventDefault();

					window.tolstoyWidget.recreate("5pa3rnvr7bc2l");
					setTimeout(() => {
						window.tolstoyWidget.start();
					}, 1000);
				});
			});
		}
	});

	window.addEventListener("message", (message) => {
		if (message.data.name === "tolstoyModalClose") {
			window.tolstoyWidget.recreate(tolstoyId);
		}
	});
};
